export default __webpack_public_path__ + "static/kompressorsteuerung_boge-123957682fdfec8e2e6e0f82c8994934.png";